import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from '../pages/login/login';
import { GlobalProvider } from '../providers/global/global';

// import { HomePage } from '../pages/home/home';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = LoginPage;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen
    , public global: GlobalProvider) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });
    //this.listenToWebEvents();
    
  }


//   listenToWebEvents() {
//     window.onbeforeunload = (e) => {
  
//       //If user is logged in, warn them before leaving
//       if (localStorage.getItem('ContactId')) {
//         console.log('Leaving the site?  If not, please use the in-app navigation and not the back button.');
//         this.global.status = this.global.defaultstatus;
//         localStorage.setItem('Status', this.global.status);
//       }
//     };
  
//     window.onhashchange = (e) => {
  
//       //If user is logged in, warn them since they may be using the back button here
//       if (localStorage.getItem('ContactId')) {
//         //Present an alert
//         console.log('Using the back button?  If so, please use the in-app navigation and not the back button.');
//         this.global.status = this.global.defaultstatus;
//         localStorage.setItem('Status', this.global.status);

//       }
//     };
// }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts